import React, { FC, useMemo } from "react";
import { View, ViewProps } from "react-native";
import { style as headerStyle } from "./Header.style";

type HeaderProps = ViewProps;

const Header: FC<HeaderProps> = ({ children, style: customStyle, ...props }) => {
  const style = useMemo(() => headerStyle(), []);

  return (
    <View {...props} style={[style.header, customStyle]}>
      {children}
    </View>
  );
};

export { Header };
